var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7752 16.0632L16 26.6666L26.2248 16.0632C27.3614 14.8844 28 13.2857 28 11.6187C28 8.14738 25.2864 5.33331 21.9391 5.33331C20.3316 5.33331 18.79 5.99552 17.6534 7.17426L16 8.88887L14.3466 7.17426C13.21 5.99552 11.6684 5.33331 10.0609 5.33331C6.71356 5.33331 4 8.14738 4 11.6187C4 13.2857 4.63856 14.8844 5.7752 16.0632Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineHeart);
export default __webpack_public_path__ + "static/media/outline-heart.00144158c7bb6188c33e032e81798069.svg";
export { ForwardRef as ReactComponent };